module.exports = __webpack_public_path__ + "img/rightAni.b7371636.png";